import {
  ICFSMasterName,
  IKaseMasterName,
  MasterNameInvolvement,
} from '@/models';

export const REGISTERED_OWNER_REQUIRED_MESSAGE =
  'OW involvement is required because this name is the registered owner of a linked vehicle.';

export const REGISTERED_OWNER_UNLINK_MESSAGE =
  'This name cannot be unlinked because it is the registered owner of a linked vehicle.';

export const normalizeMasterNameInvolvement = (
  value: unknown,
): MasterNameInvolvement[] => {
  if (Array.isArray(value)) {
    return value
      .map((item) =>
        typeof item === 'string'
          ? item
          : (item as { value?: string; code?: string; label?: string })
              ?.value ||
            (item as { value?: string; code?: string; label?: string })?.code ||
            (item as { value?: string; code?: string; label?: string })
              ?.label ||
            '',
      )
      .filter(Boolean) as MasterNameInvolvement[];
  }

  if (typeof value === 'string') {
    return [value as MasterNameInvolvement];
  }

  if (value && typeof value === 'object') {
    const item = value as { value?: string; code?: string; label?: string };

    return [item.value || item.code || item.label || ''].filter(
      Boolean,
    ) as MasterNameInvolvement[];
  }

  return [];
};

const getRegisteredOwnerVehicles = (
  masterName: ICFSMasterName | IKaseMasterName | null | undefined,
) =>
  'registeredOwnerVehicles' in (masterName || {})
    ? masterName?.registeredOwnerVehicles
    : undefined;

export const isVehicleLinkedRegisteredOwner = (
  masterName: ICFSMasterName | IKaseMasterName | null | undefined,
) => Boolean(getRegisteredOwnerVehicles(masterName)?.length);

export const removesRequiredOwnerInvolvement = (
  masterName: ICFSMasterName | IKaseMasterName | null | undefined,
  involvement: unknown,
) =>
  isVehicleLinkedRegisteredOwner(masterName) &&
  !normalizeMasterNameInvolvement(involvement).includes(
    MasterNameInvolvement.OWNER,
  );

export const disableOwnerInvolvementOption = <
  T extends { value: string | number; disabled?: boolean },
>(
  items: T[],
  masterNameOrLocked:
    | ICFSMasterName
    | IKaseMasterName
    | null
    | undefined
    | boolean,
) =>
  items.map((item) =>
    item.value === MasterNameInvolvement.OWNER &&
    (typeof masterNameOrLocked === 'boolean'
      ? masterNameOrLocked
      : isVehicleLinkedRegisteredOwner(masterNameOrLocked))
      ? { ...item, disabled: true }
      : item,
  );
